var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.appearance
    ? _c(
        "div",
        {
          staticClass: "price-update-date d-flex w-100",
          class: [
            _setup.isMobile ? "justify-start" : "justify-end",
            { "price-update-date--v5": _setup.ff_lpu_branding_page_v5 },
          ],
        },
        [
          _c(
            "div",
            {
              staticClass: "price-update-date__text text-caption",
              class: {
                "price-update-date__text--fresh":
                  _setup.appearance.tone === "fresh",
                "price-update-date__text--stale":
                  _setup.appearance.tone === "stale",
                "price-update-date__text--outdated":
                  _setup.appearance.tone === "outdated",
              },
              attrs: { "data-qa": "lpu_services_service_date_updated_text" },
            },
            [_vm._v("\n    " + _vm._s(_setup.appearance.text) + "\n  ")]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }